import { Box, Card, FormControl, InputLabel, Stack, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

import { useDispenseAssets } from '@/hooks/useDispenseAssets';

import type { ResidualBagContentView } from '@/types/generated/athena';

type Props = {
  content: ResidualBagContentView;
  onChange?: (billId: string, count: number | null) => void;
};

const ReconciliationCard = ({ content, onChange }: Props) => {
  const { billsMap } = useDispenseAssets();
  const { estimated_note_count, bill_note_id } = content;
  const [count, setCount] = useState<string>('');

  useEffect(() => {
    const value = Number.parseInt(count) ?? null;
    onChange?.(bill_note_id ?? '', !Number.isNaN(value) ? value : null);
  }, [count]);

  return (
    <Card sx={{ height: '100%', bgcolor: 'neutral.50' }}>
      <Stack p={2} height="100%" gap={2}>
        <Typography variant="overline" sx={{ borderLeft: '4px solid red', pl: 2 }}>
          {billsMap[bill_note_id!]?.at(0) ?? '-'} ({billsMap[bill_note_id!]?.at(1) ?? '-'})
        </Typography>
        <Box>
          <Typography variant="body2" color="text.secondary">
            Expected Amount
          </Typography>
          <Typography variant="body1">{estimated_note_count}</Typography>
        </Box>
        <FormControl fullWidth>
          <InputLabel variant="standard" size="small">
            Amount
          </InputLabel>
          <TextField
            onChange={({ target: { value } }) => setCount(value)}
            sx={{ bgcolor: 'white' }}
            placeholder="Amount"
            value={count}
          />
        </FormControl>
      </Stack>
    </Card>
  );
};

export default ReconciliationCard;
